module.exports = __webpack_public_path__ + "img/Knuddeln.9ab6c126.svg";